module.exports = __webpack_public_path__ + "media/images/sponsorBanner__right__bottom-ced9dc5ce33584e08e12f7d16ce37b01.png";